export default __webpack_public_path__ + "static/collage-d0619d109318e3e218f1aad74b9234ac.webp";